import axios from 'axios';
import http from "./create_axios";

class Admin {
    auth(pass){
        return http.post("/api",{type:"auth",pass:pass});
    }
    getToken() {
        return localStorage.getItem("adminToken");
    }
    setToken(token) {
        if (token) {
            localStorage.setItem("adminToken", token);
        } else {
            localStorage.removeItem("adminToken");
        }
    }
    getInfo(){
        return http.post("/api",{type:"get_information"}, {
            headers: {"x-admin-token": this.getToken() || ""}
        });
    }
    sendRequest(data){
        return http.post("/api",data, {
            headers: {"x-admin-token": this.getToken() || ""}
        });
    }

    disableSize(id) {
        return http.post("/api",{type:"disable_size",_id:id}, {
            headers: {"x-admin-token": this.getToken() || ""}
        });
    }
}
export default new Admin();